/**
 * The words of an existing-equipment photo (pieces 19 and 35; decision 5440;
 * row T2743): the camera tile's Add Photo, its kind and note step, the Need
 * row's grid, count and No Existing Equipment mark, the Files tile's Existing
 * Equipment group, the web Upload window's Kind and File details' position,
 * and the Settings section holding the kinds. Spread into the one string lookup.
 */
export const EQUIPMENT_PHOTO_STRINGS = {
  'equipment.addPhoto': 'Add Photo',
  'equipment.kindTitle': 'What the Photo Shows',
  'equipment.kindTyped': 'Another Kind',
  'equipment.note': 'Note',
  'equipment.next': 'Next',
  'equipment.pickKind': 'Pick what the photo shows, or type another kind.',
  'equipment.sending': 'Sending the photo…',
  'equipment.filed': 'The photo is filed with its kind and its position.',
  'equipment.filedNoPosition': 'The photo is filed with its kind and no position.',
  'equipment.notFiled': 'The photo was not filed.',
  'equipment.typesNeeded': 'The file types were not read while the page had a signal, so the photo cannot be filed yet.',
  'equipment.none': 'No Existing Equipment',
  'equipment.noneLine': 'No existing equipment on site.',
  'equipment.countOne': '1 photo of the existing equipment',
  'equipment.countMany': '{count} photos of the existing equipment',
  'equipment.group': 'Existing Equipment',
  'equipment.otherFiles': 'Other Files',
  'equipment.unit': 'Unit {number}',
  'equipment.noPosition': 'No Position',
  'equipment.kind': 'Kind',
  'equipment.kindNone': 'Not an equipment photo',
  'equipment.position': 'Position',
  'equipment.positionNone': 'No position was recorded.',
  'equipment.waiting': 'waiting to sync',
  'settings.deals.equipmentPhotos': 'Equipment Photos',
  'settings.deals.equipmentPhotosHint': 'The kinds a camera on a Deal’s Need offers, one per line. A kind somebody types on the phone is added here.',
  'settings.deals.photoKinds': 'Equipment Photo Kinds',
} as const;
